import React from 'react';
import { connect } from 'react-redux';
import { APP_LANGUAGE_SUPPORTS } from '@/constants/app';

class NameRender extends React.Component {
  render() {
    const { data, stockName, chineseStockName, language } = this.props;
    switch (language.lang) {

      case APP_LANGUAGE_SUPPORTS[1].id: {
        return (
          <div>
            <span>
              {data[chineseStockName] ? data[chineseStockName] : data[stockName] ? data[stockName] : '-'}
            </span>
          </div>
        )
      }
      case APP_LANGUAGE_SUPPORTS[0].id: {
        return (
          <div>
            <span>
              {data[chineseStockName] ? data[chineseStockName] : data[stockName] ? data[stockName] : '-'}
            </span>
          </div>
        )
      }
      default: {
        return (
          <div>
            <span>
              {data[stockName] ? data[stockName] : '-'}
            </span>
          </div>
        )
      }
    }
  }
}

export default connect(
  state => ({
    language: state.app.language
  })
)(NameRender)
